import React, { useState, useEffect } from "react";
import "./EmployeeTable.css";

const EmployeeTable = ({ data, showRegistrationFilter = false }) => {
  const [search, setSearch] = useState("");
  const [departmentFilter, setDepartmentFilter] = useState("");
  const [registrationFilter, setRegistrationFilter] = useState("");

  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    let temp = [...data];

    // Search by name
    if (search.trim() !== "") {
      temp = temp.filter((item) =>
        item.name?.toLowerCase().includes(search.toLowerCase()) || item.empId?.toLowerCase().startsWith(search.toLowerCase())
      );
    }

    // Filter by department
    if (departmentFilter !== "") {
      temp = temp.filter((item) => item.department === departmentFilter);
    }

    // Filter by registration status
    if (registrationFilter !== "") {
      temp = temp.filter(
        (item) =>
          (registrationFilter === "registered" && item.registered === true) ||
          (registrationFilter === "not-registered" && item.registered === false)
      );
    }

    setFilteredData(temp);
  }, [search, departmentFilter, registrationFilter, data]);

  return (
    <div className="employee-table-container">

      {/* Filters */}
      <div className="filters-wrap">

        <input
          type="text"
          placeholder="Search by Emp Id or Name..."
          className="filter-input"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        {/* <select
          className="filter-select"
          value={departmentFilter}
          onChange={(e) => setDepartmentFilter(e.target.value)}
        >
          <option value="">Department</option>
          <option value="HR">HR</option>
          <option value="IT">Tech</option>
          <option value="Finance">Finance</option>
          <option value="Management">Management</option>
        </select> */}

        {showRegistrationFilter && (
          <select
            className="filter-select"
            value={registrationFilter}
            onChange={(e) => setRegistrationFilter(e.target.value)}
          >
            <option value="">Registration Status</option>
            <option value="registered">Registered</option>
            <option value="not-registered">Not Registered</option>
          </select>
        )}
      </div>

      {/* Table */}
      <div className="table-wrapper">
        <table className="employee-table">
          <thead>
            <tr>
              <th>Emp ID</th>
              <th>Name</th>
              <th>Department</th>
              {showRegistrationFilter && <th>Registered</th>}
            </tr>
          </thead>

          <tbody>
            {filteredData.length === 0 ? (
              <tr>
                <td colSpan="4" className="no-data">
                  No records found
                </td>
              </tr>
            ) : (
              filteredData.map((item, index) => (
                <tr key={index}>
                  <td>{item.empId}</td>
                  <td>{item.name}</td>
                  <td>{item.department || "N/A"}</td>
                  {showRegistrationFilter && (
                    <td className={item.registered ? "reg-yes" : "reg-no"}>
                      {item.registered ? "Yes" : "No"}
                    </td>
                  )}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

    </div>
  );
};

export default EmployeeTable;
